module.exports = {
    login:'登入',
    taption: 'Taption',
    ways_to_use_taption:'简单教学',
    faq:'常见问题',
    pricing:'价格',
    language:'语言',
    product:'产品介绍'
  }